import React, { useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { toggleModal } from '../../../../../reducers/modalReducer.js';
import Modal from '@mui/material/Modal';
import { postRequest, showMessage } from '../../../../../config';

const AppStore = ({ company, setTab, user, permissionLevel }) => {

    const dispatch = useDispatch();
    const modal = useSelector(state => state.modal);

    let [selectedThingsToDo, setSelectedThingsToDo] = useState({});

    const handleThingsToDo = (item) => {
        if (item?.['needToGenerate']) {
            const alreadyCreated = company?.['generateChecklistModules']?.find(m => m['moduleName'] === item['type']);
            if (alreadyCreated) {
                window.location.href = `/company/${company['_id']}`
                window.location.reload();
                return;
            }
            if (!Object.keys(item['module']).length) {
                window.location.hash = item['type'];
                setTab(item['type'], true);
                return;
            }
            generatePartnerModule(item['module']);
            return;
        } else if (item?.['isPopup']) {
            setSelectedThingsToDo(item);
            dispatch(toggleModal({ open: 'thingsToDo' }));
        } else {
            window.open(item['websiteUrl'], '_blank');
        }
    };

    const APP_STORE_PARTNERS = [
        {
            isPopup: false,
            needToGenerate: true,
            logo: 'https://checklist-icons.s3.us-east-2.amazonaws.com/Cybersecurity_Basics.png',
            icon: 'https://checklist-icons.s3.us-east-2.amazonaws.com/Cybersecurity_Basics.png',
            module: company?.['extraModules']?.find(item => item['moduleName'] == 'Cyber DueDil') || {},
            type: 'Cyber DueDil',
            title: 'SME DueDil',
            bottomText: 'Including 30-minute video consultation',
            btnText: 'More',
            website: '',
            websiteUrl: '',
            bookCall: '',
            rightSideImg: `url(${require('../../../../../../images/thingstodo/standard_right_bg.png')})`,
            content: {
                topHeading: 'Cyber DueDil',
                mainHeading: <>Partner Pack - <br /> Cyber DueDil</>,
                points: [
                    'Get a report on what to fix personalized to your business',
                    'Organize key documents',
                    'Business audit',
                    'Risks and recommendations',
                    'Diligence reports to show buyers'
                ],
                boxes: [],
                stepImage: require('../../../../../../images/step-5-modal-img.png'),
                arrayImages: [
                    require('../../../../../../images/partner-checklist/bfs-step-1.png'),
                    require('../../../../../../images/partner-checklist/bfs-step-2.png'),
                    require('../../../../../../images/partner-checklist/bfs-step-3.png'),
                    require('../../../../../../images/partner-checklist/bfs-step-4.png'),
                    require('../../../../../../images/partner-checklist/bfs-step-5.png')
                ],
                extraModule: {
                    text: <>Enhance your value and speed of sale on Businesses For Sale</>,
                    btnText: 'Free'
                },
                seeMore: {
                    icon: <img src={'https://checklist-icons.s3.us-east-2.amazonaws.com/Cybersecurity_Basics.png'} alt="" />,
                    title: <>Partner Pack - <br /> Cyber DueDil</>,
                    points: [
                        'Get a report on what to fix personalized to your business',
                        'Organize key documents',
                        'Business audit',
                        'Risks and recommendations',
                        'Diligence reports to show buyers'
                    ],
                    image: require('../../../../../../images/partner-checklist/bfs-intro.png'),
                    imageStyle: { height: '70%', width: '70%' }
                }
            }
        },
        {
            isPopup: false,
            needToGenerate: true,
            logo: 'https://checklist-icons.s3.us-east-2.amazonaws.com/abf-partner-logo.png',
            icon: 'https://checklist-icons.s3.us-east-2.amazonaws.com/abf-partner-logo.png',
            module: company?.['extraModules']?.find(item => item['moduleName'] == 'Alternative Business Funding') || {},
            title: 'Loan readiness Checklist',
            type: 'Alternative Business Funding',
            bottomText: 'Loan readiness checklist for application to 140 lenders via ABF - increase your chances',
            btnText: 'More',
            website: '',
            websiteUrl: '',
            bookCall: '',
            rightSideImg: `url(${require('../../../../../../images/thingstodo/standard_right_bg.png')})`,
            content: {
                topHeading: 'Bespoked financial analysis from your own AI finance copilot',
                mainHeading: 'Instant financial insights from your accounting data - in plain English',
                bottomHeading: 'Financial analysis that works alongside CFOs and finance teams not instead of them',
                points: [
                    'Connects directly to Xero, Quickbooks and other accounting platforms',
                    'Ask natural‑language questions and get tailored financial analysis instantly',
                    'Hyper‑bespoke reporting across cash flow, margins, runway and performance',
                    'Proactive, actionable insights — not static dashboards',
                    'Fast to deploy, cost‑effective and finance team friendly',
                ],
                bottomText: 'Designed to support your judgement with faster, deeper financial visibility',
            }
        },
        {
            isPopup: false,
            needToGenerate: true,
            logo: 'https://checklist-icons.s3.us-east-2.amazonaws.com/bfs-partner-logo.png',
            icon: 'https://checklist-icons.s3.us-east-2.amazonaws.com/bfs-partner-logo.png',
            module: company?.['extraModules']?.find(item => item['moduleName'] == 'Business For Sale') || {},
            type: 'Business For Sale',
            title: 'Sale readiness checklist',
            bottomText: 'Enhance your value and speed of sale on Businesses For Sale',
            btnText: 'More',
            website: '',
            websiteUrl: '',
            bookCall: '',
            rightSideImg: `url(${require('../../../../../../images/thingstodo/standard_right_bg.png')})`,
            content: {
                topHeading: 'Business For Sale',
                mainHeading: <>Partner Pack - <br /> Business For Sale</>,
                points: [
                    'Get a report on what to fix personalized to your business',
                    'Organize key documents',
                    'Business audit',
                    'Risks and recommendations',
                    'Diligence reports to show buyers'
                ],
                boxes: [],
                stepImage: require('../../../../../../images/step-5-modal-img.png'),
                arrayImages: [
                    require('../../../../../../images/partner-checklist/bfs-step-1.png'),
                    require('../../../../../../images/partner-checklist/bfs-step-2.png'),
                    require('../../../../../../images/partner-checklist/bfs-step-3.png'),
                    require('../../../../../../images/partner-checklist/bfs-step-4.png'),
                    require('../../../../../../images/partner-checklist/bfs-step-5.png')
                ],
                extraModule: {
                    text: <>Enhance your value and speed of sale on Businesses For Sale</>,
                    btnText: 'Free'
                },
                seeMore: {
                    icon: <img src={'https://checklist-icons.s3.us-east-2.amazonaws.com/bfs-partner-logo.png'} alt="" />,
                    title: <>Partner Pack - <br /> Business For Sale</>,
                    points: [
                        'Get a report on what to fix personalized to your business',
                        'Organize key documents',
                        'Business audit',
                        'Risks and recommendations',
                        'Diligence reports to show buyers'
                    ],
                    image: require('../../../../../../images/partner-checklist/bfs-intro.png'),
                    imageStyle: { height: '70%', width: '70%' }
                }
            }
        },
        {
            isPopup: true,
            logo: require('../../../../../../images/thingstodo/duedig_logo.png'),
            icon: require('../../../../../../images/dueDig.png'),
            title: 'Due Dig',
            bottomText: 'Software code diligence and reviews',
            btnText: 'More',
            website: 'www.duedig.co.uk',
            websiteUrl: 'https://www.duedig.co.uk/',
            bookCall: 'https://calendly.com/duedig/intro',
            rightSideImg: `url(${require('../../../../../../images/thingstodo/standard_right_bg.png')})`,
            content: {
                topHeading: 'CTO -led Tech Due Diligence',
                mainHeading: <>Tech Due Diligence For Early Stage Companies <br /> & Investors</>,
                points: [
                    <><b>Expert CTO Lens</b> -  deep code & architecture review by seasoned CTOs</>,
                    <><b>Actionable Scorecard</b> - Clear risk ratings and red-flag heatmap for IC memo</>,
                    <><b>Rapid Turnaround</b> - Speed that matches transaction pace without sacrificing rigor</>,
                ],
                boxes: [
                    { title: '$850M', subTitle: 'CAPITAL UNDER REVIEW' },
                    { title: '75+ years', subTitle: 'COMBINED CTO EXPERIENCE' },
                    { title: '10 days', subTitle: 'AVG. TURNAROUND' },
                ],
                bottomText: 'Get your board-ready tech risk report in 7-10 days.',
            }
        },
        {
            isPopup: true,
            logo: require('../../../../../../images/thingstodo/knoli_logo.png'),
            icon: require('../../../../../../images/knolli.png'),
            title: 'Knolli.ai',
            bottomText: 'Build your own Ai financial agents',
            btnText: 'More',
            website: 'www.knolli.ai',
            websiteUrl: 'https://www.knolli.ai/',
            bookCall: 'https://cal.com/mandeeptaunk/30min',
            rightSideImg: `url(${require('../../../../../../images/thingstodo/knoli_right_bg_one.png')}), url(${require('../../../../../../images/thingstodo/knoli_right_bg_two.png')})`
        },
        {
            isPopup: true,
            logo: require('../../../../../../images/thingstodo/genfinance.ai_logo.png'),
            icon: require('../../../../../../images/thingstodo/genfinance.ai.png'),
            title: 'GenFinance.ai',
            bottomText: 'Company Valuation Report',
            btnText: 'More',
            website: 'www.genfinance.ai',
            websiteUrl: 'https://www.genfinance.ai/',
            bookCall: 'https://cal.com/team/genfinance-ai/intro-company',
            rightSideImg: `url(${require('../../../../../../images/thingstodo/standard_right_bg.png')})`,
            content: {
                topHeading: 'Big 4-trained finance AI experts',
                mainHeading: 'AI For Finance, By Finance Professionals',
                bottomHeading: 'Accelerating finance teams to become genuine strategic powerhouses, through responsible innovation and measurable results',
                points: [
                    'Finance AI Readiness Scorecard',
                    'AI Savings Finder',
                    'Board-Ready AI Strategy',
                    'Done For You Ai-Deployment',
                ],
                boxes: [
                    { title: '£1.7bn', subTitle: 'Cost Savings to be captured from using AI  (UK Economy 2024)' },
                    { title: '10+ years', subTitle: 'Combined Experience' },
                    { title: '28', subTitle: 'Finance Team Projects' },
                ]
            }
        },
        {
            isPopup: true,
            logo: require('../../../../../../images/thingstodo/yoono.ai_logo.png'),
            icon: require('../../../../../../images/thingstodo/yoono.ai.png'),
            title: 'Yoono.Ai',
            bottomText: 'Diligence individuals and management teams',
            btnText: 'More',
            website: 'www.yoono.ai',
            websiteUrl: 'https://www.yoono.ai/',
            bookCall: 'https://yoono.ai/demo-request',
            rightSideImg: `url(${require('../../../../../../images/thingstodo/standard_right_bg.png')})`,
            content: {
                topHeading: 'YOONO helps you search, verify and understand public information - ethically and intelligently',
                mainHeading: 'Detailed diligence reports on people in minutes',
                bottomHeading: 'You diligence the business. How do you quickly and inexpensively diligence the people?',
                points: [
                    'Enter a name and employer, or upload a CV or LinkedIn profile',
                    'Our engine cross-checks and analyses public data, employment history, media mentions, social profiles, and more to validate accuracy',
                    'Review a clear, moderated report highlighting verified facts, potential discrepancies, and concerning content, ethically sourced and ready to use',
                    'Ready in minutes',
                ],
                boxes: [
                    { title: <>£200<span class='ml0-5rem fw300 fs0-75rem c12'>plus VAT</span></>, subTitle: 'Individual report' },
                    { title: <>£800<span class='ml0-5rem fw300 fs0-75rem c12'>plus VAT</span></>, subTitle: <>Team bundle x5 reports <br /> (get one free)</> },
                    { title: '', subTitle: 'Self-diligence and include in Diligentsia diligence pack to speed transaction completion' },
                ]
            }
        },
        {
            isPopup: true,
            logo: require('../../../../../../images/thingstodo/kissthefish_logo.png'),
            icon: require('../../../../../../images/thingstodo/kissthefish.png'),
            title: 'Kiss The Fish',
            bottomText: 'Accelerated sales growth with fractional sales directors',
            btnText: 'More',
            website: 'www.kissthefish.net',
            websiteUrl: 'https://www.kissthefish.net/',
            bookCall: 'https://www.kissthefish.net/',
            rightSideImg: `url(${require('../../../../../../images/thingstodo/standard_right_bg.png')})`,
            content: {
                topHeading: 'Fractional Sales Directors',
                mainHeading: 'Accelerate revenue with strategic sales leadership — without the full-time cost',
                bottomHeading: 'On-demand senior sales leadership, coaching & strategy. Transform inconsistent sales into predictable, scalable growth.',
                points: [
                    'Fractional Sales Directors embedded in your business',
                    'Board-level sales strategy & diagnostics',
                    'Coaching to up skill your team',
                    'Flexible engagement — pay for only what you need',
                    'Proven revenue acceleration results',
                ],
                bottomText: 'Tailored sales leadership — delivered in flexible packages to suit your business needs',
            }
        },
        {
            isPopup: true,
            logo: require('../../../../../../images/thingstodo/nume_logo.png'),
            icon: require('../../../../../../images/thingstodo/nume.png'),
            title: 'Nume',
            bottomText: 'Onboard Your AI CFO In 5 Minutes',
            btnText: 'More',
            website: 'www.nume.ai',
            websiteUrl: 'https://www.nume.ai/',
            bookCall: 'https://www.nume.ai/',
            rightSideImg: `url(${require('../../../../../../images/thingstodo/standard_right_bg.png')})`,
            content: {
                topHeading: 'Bespoked financial analysis from your own AI finance copilot',
                mainHeading: 'Instant financial insights from your accounting data - in plain English',
                bottomHeading: 'Financial analysis that works alongside CFOs and finance teams not instead of them',
                points: [
                    'Connects directly to Xero, QuickBooks and other accounting platforms',
                    'Ask natural‑language questions and get tailored financial analysis instantly',
                    'Hyper‑bespoke reporting across cash flow, margins, runway and performance',
                    'Proactive, actionable insights — not static dashboards',
                    'Fast to deploy, cost‑effective and finance team friendly',
                ],
                bottomText: 'Designed to support your judgement with faster, deeper financial visibility',
            }
        },
        {
            isPopup: true,
            logo: require('../../../../../../images/thingstodo/startup2standup_logo.png'),
            icon: require('../../../../../../images/thingstodo/startup2standup.png'),
            title: 'Startup 2 Standup',
            bottomText: 'Founder community to support your journey',
            btnText: 'More',
            website: 'www.startup2standup.com',
            websiteUrl: 'https://www.startup2standup.com/',
            bookCall: 'https://calendly.com/ollie-startup2standup/15min',
            content: {
                topHeading: 'A founder community built to cut through isolation and drive growth with peer support',
                mainHeading: 'A supportive network and structured resources for startup and growth founders',
                bottomHeading: 'Shared experience, encouragement and practical insight to accelerate your journey',
                points: [
                    'Community of founders who understand the entrepreneurial grind',
                    'Peer-to-peer support, shared learning and encouragement',
                    'Group sessions, expert input and practical workshops',
                    'Access to a curated network of investors and specialist advisors',
                    'Expert insight at a founder-friendly, low-cost entry point',
                ],
                bottomText: 'Supportive ecosystem tailored to early-stage and scaling founders',
            }
        },
        {
            isPopup: true,
            logo: require('../../../../../../images/thingstodo/freshbat_logo.png'),
            icon: require('../../../../../../images/thingstodo/freshbat.png'),
            title: 'Freshbat Strategic Marketing',
            bottomText: 'Polish traction and GTM strategy for investment readiness',
            btnText: 'More',
            website: 'www.freshbat.com',
            websiteUrl: 'https://www.freshbat.com/',
            bookCall: 'https://freshbat.com/contact/',
            content: {
                topHeading: 'Go-to-market specialist growth consultancy ',
                mainHeading: 'Low-cost GTM expertise to help early-stage companies prove traction and investor readiness',
                bottomHeading: <span>Targeted go-to-market strategy reviews designed for fundraising success<br />Clarify route-to-market, traction levers and commercial narrative — fast</span>,
                points: [
                    'Strengthen your investment story with a credible GTM plan',
                    'Identify the fastest path to early traction and revenue signals',
                    'Avoid common GTM mistakes that put investors off',
                    'Clear actions founders can execute immediately',
                    'Expert insight at a founder-friendly, low-cost entry point',
                ],
                bottomText: 'Boost your marketing strategy in a day ....',
            }
        },
        {
            isPopup: true,
            logo: require('../../../../../../images/thingstodo/goeo_logo.png'),
            icon: require('../../../../../../images/thingstodo/goeo.png'),
            title: 'Go EO',
            bottomText: 'Experts in Employee Ownership Trust setup and management',
            btnText: 'More',
            website: 'www.goeo.uk',
            websiteUrl: 'https://www.goeo.uk/',
            bookCall: 'https://goeo.uk/contact',
            rightSideImg: `url(${require('../../../../../../images/thingstodo/standard_right_bg.png')})`,
            content: {
                topHeading: 'Structured, cost effective Employee Ownership Trust (EOT) sales',
                mainHeading: 'Expert EOT providers, from feasibility to completion',
                bottomHeading: 'End-to-end EOT management - taking care of the technical complexity and ensuring each step runs smoothly and speedily.',
                points: [
                    'Complete process: financials, tax clearance, trust set up, legal docs, submissions',
                    'Founded by a Chartered Tax Adviser who sold his own business to an EOT in 2021',
                    'Highly recommended with multiple 5 star reviews on Google and Trustpilot',
                    'Specialists in businesses with 5–25 employees, valuations up to £5m',
                    'Straightforward, affordable and simple process',
                ],
                bottomText: 'Streamlined EOT sales service for founders and professional advisers',
            }
        },
        {
            isPopup: true,
            logo: require('../../../../../../images/thingstodo/intelectgroup_logo.png'),
            icon: require('../../../../../../images/thingstodo/intelectgroup.png'),
            title: 'Intelect Group',
            bottomText: 'Inexpensive external diligence on people in minutes',
            btnText: 'More',
            website: 'www.intelect-group.com',
            websiteUrl: 'https://www.intelect-group.com/',
            bookCall: 'https://intelect-group.com/book-a-call/',
            rightSideImg: `url(${require('../../../../../../images/thingstodo/standard_right_bg.png')})`,
            content: {
                topHeading: 'Independent third-party due diligence on directors & senior management',
                mainHeading: 'External verification and risk insight on leadership teams — beyond self-disclosure',
                bottomHeading: 'Objective verification to validate disclosures and identify hidden risk',
                points: [
                    'Third-party verification of director & senior management disclosures',
                    'Builds on Diligentsia’s self-reported Directors’ Questionnaires',
                    'Investigator-led integrity, reputation and conduct checks',
                    'Clear, decision-ready reporting for investors, boards and advisers',
                    'Diligence a whole team in hours - and gain peace of mind',
                ],
                bottomText: 'Inexpensive - from as little as £50 per Director or manager',
            }
        },
        // {
        //     isPopup: true,
        //     logo: require('../../../../../../images/thingstodo/brownrudnick_logo.png'),
        //     icon: require('../../../../../../images/thingstodo/brownrudnick.png'),
        //     title: 'Brown Rudnick LLP',
        //     bottomText: 'Avoid the top 10 causes of delayed transactions',
        //     btnText: 'More',
        //     website: 'www.brownrudnick.com',
        //     websiteUrl: 'https://www.brownrudnick.com/',
        //     bookCall: 'https://brownrudnick.com/contact-us/',
        //     content: {
        //         topHeading: 'Boutique 200-member law firm specialising in transaction work',
        //         mainHeading: 'Complete our checklist to avoid the top 10 causes of delayed transactions',
        //         bottomHeading: '20 minutes now could save weeks of delay later...',
        //         points: [
        //             '10 section checklist',
        //             'Risks and recommendations, reporting and Workflow Manager',
        //             'Designed for founders, C-Suite and advisors',
        //             'Helpful explanations and templates',
        //             'Added to your Diligentsia dashboard',
        //         ],
        //         bottomText: 'Once completed, we’d love to talk through your results....',
        //     }
        // },
        {
            isPopup: true,
            logo: require('../../../../../../images/thingstodo/greenripple_logo.png'),
            icon: require('../../../../../../images/thingstodo/greenripple.png'),
            title: 'Green Ripple',
            bottomText: 'Forensic pitch preparation, traction & investor strategy',
            btnText: 'More',
            website: 'www.greenripple.co',
            websiteUrl: 'https://www.greenripple.co/',
            bookCall: 'https://www.greenripple.co/',
            content: {
                topHeading: 'Forensic investment readiness coaching that turns your story into investor-ready conviction',
                mainHeading: 'Sharpen your investor pitch — narrative, clarity & traction that investors recognise',
                bottomHeading: <span>Intensive pitch and investment proposition preparation for early stage companies<br />Deep refinement of narrative, customer insights and evidence that investors prioritise</span>,
                points: [
                    'Investor messaging that answers “Why you? Why now?” with evidence-based clarity',
                    'Structured pitch review and refinement to surface traction-focused milestones',
                    'Alignment of market positioning, customer need and unique value proposition',
                    'Data-driven differentiation so investors instantly grasp your edge',
                    'Playbook to engage the right investors and convert interest into term sheets',
                ],
                bottomText: 'Focused investment storytelling and readiness — not generic marketing or consultancy',
            }
        },
        {
            isPopup: true,
            logo: require('../../../../../../images/thingstodo/flocast_logo.png'),
            icon: require('../../../../../../images/thingstodo/flocast.png'),
            title: 'Flocast',
            bottomText: 'Plug & play cashflow modelling',
            btnText: 'More',
            website: 'www.flocast.co.uk',
            websiteUrl: 'https://www.flocast.co.uk/',
            bookCall: 'https://flocast.co.uk/#book-a-demo',
            content: {
                topHeading: 'A simple, plug-and-play cashflow app that helps founders and CFOs see what’s coming next',
                mainHeading: 'Real-time cashflow visibility, forecasting and funding access for growing businesses',
                bottomHeading: 'A practical tool fractional CFOs can use to give clients faster, clearer financial insight',
                points: [
                    'Ideal for fractional CFOs supporting multiple SME clients',
                    'Instant cashflow forecasts and real-time financial visibility',
                    'Helps clients plan for VAT, cash pinch points and funding needs',
                    'Plug-and-play setup with rolling monthly contract',
                    'No hidden fees and built for founders and growing SMEs',
                ],
                bottomText: 'Simple monthly pricing, fast setup and practical insight for everyday finance decision',
            }
        },
    ];
    const generatePartnerModule = async (module) => {
        // CHECK EXPANSION PACK PERMISSIONS LEVEL OF ADVISORS/INVESTORS
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && (permissionLevel == 'DASHBOARD' || permissionLevel == 'DASHBOARD & REPORT')) {
            showMessage(`You have ${permissionLevel} access only!`);
            dispatch(toggleModal({ open: '' }))
            return;
        }

        let data = {
            category: 'partner',
            partnerId: module['_id'],
            companies: { [company['_id']]: company['cName'] },
            memberPermissions: { [user['_id']]: { ...user, company: { [company['_id']]: company['cName'] } } }
        }
        dispatch(toggleModal({ open: 'generatePartnerPopup' }));
        const res = await postRequest(`/checklist/create/0`, data);
        if (res?.['code'] == 200) {
            const isNewUrl = window.location.pathname.includes('/company/');
            window.location.href = `/company/${company['_id']}`
        }
        dispatch(toggleModal({ open: '' }));
    };

    return (
        <div className='w100 df fdc aic jcc pb5rem'>
            <div className='w100 df fdc aic jcc'>
                <div className='w100 df fdc aic jcc my2rem'>
                    <h2 className='fs1-5rem fw500 c15 w100 tac'>AppStore</h2>
                </div>
            </div>
            <div className="box-dashbord-contaxiner mla mra mb6rem mt2rem" style={{ width: '98%' }}>
                <div className="df fww pr w100 bg20 p2rem py2rem pb6rem keyfeature-box keyfeature-box-company-pro mb2rem bss bo28 bw1px br25px">
                    <div className="df fdc aifs tac" style={{ width: '20%' }}>
                        <div className='df fdc aifs tac'>
                            <h3 className="fs1-25re c15 w100 tal">Our Partners</h3>
                        </div>
                        <div className='mt2rem'>
                            <img src={require(`../../../../../../images/dashboard/appStore.svg`)} style={{ width: '230px', height: '251px' }} alt="dashboardIcon" />
                        </div>
                    </div>
                    <div className='dg gg1rem gtcr3 fww coreworkspace-update' style={{ width: '75%' }}>
                        {APP_STORE_PARTNERS.map((item, index) => {
                            return <div className={`bo7 w100 keyfeature-wihte-item bg1 new-shadow br15px px2rem py1rem pr bsbb`}>
                                <div className='cp right-info-hyper-icon' style={{ right: '-20px', top: '-20px' }}>
                                    <div className='questionmark pr'><img className="" src={require(`../../../../../../images/three-dot-icon.png`)} alt="" /></div>
                                </div>
                                <div class='w100 h100 df jcsb fdc'>
                                    <div class='df aic pt0-5rem'>
                                        <img className="mr1rem br5px" style={index === 0 ? { backgroundColor: '#F6EBFF', width: '60px', height: '60px', objectFit: 'contain' } : [1, 3, 4].includes(index) ? { border: '1px solid #E3E3E3', borderRadius: '10px', width: '60px', height: '60px', objectFit: 'contain', padding: '0.25rem' } : {}} src={item['icon']} alt="" />
                                        <div className='df fdc' onClick={() => handleThingsToDo(item)}>
                                            <p class='w100 fs0-75rem cp c3'>Partner</p>
                                            <p class='w100 cp c15'>{item['title']}</p>
                                        </div>
                                    </div>
                                    <div class='df jcsb aife'>
                                        <p class='fs0-875rem c12 mr0-5rem'>{item['bottomText']}</p>
                                        {item['needToGenerate']
                                            ? <img className="" src={require(`../../../../../../images/thingstodo/partners-30-minutes.png`)} alt="" />
                                            : <button onClick={() => handleThingsToDo(item)} class='cp c1 bg4 fs0-75rem br20px px2rem py0-75rem' style={{ maxHeight: '42px' }}>{item['btnText']}</button>
                                        }
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </div>



            {/* Things To Do Popup */}
            <Modal open={modal['open'] == 'thingsToDo'} onClose={() => { setSelectedThingsToDo({}), dispatch(toggleModal({ open: '' })) }} className="backdrop td500 zi4 df jcc aic" >
                <div className="poppins-font-style w100 maw1300px mah100 bg1 shadow df jcc pr">
                    {Object.keys(selectedThingsToDo).length > 0 && <>
                        <div class='w70 pl5rem px3rem py2rem'>
                            <div class='w100 h100 df fdc jcsb'>
                                <div class='df jcsb'>
                                    <a href={selectedThingsToDo['websiteUrl']} target='_blank' class='cp df fdc c15 fs0-75rem'>
                                        <img className="w50" src={selectedThingsToDo['logo']} alt="" />
                                        <p class='w100 mt0-5rem ml0-5rem c4 c3-hover'>{selectedThingsToDo['website']}</p>
                                    </a>
                                    <p class='fs1-25rem c15'>App<span class='c4'>Store</span> Partner Program</p>
                                </div>
                                {selectedThingsToDo['title'] == 'Knolli.ai' &&
                                    <div class='w100 df fdc c15 my2rem'>
                                        <p class='w100 fs2rem fw500'>Finance Function AI Specialists</p>
                                        <p class='w100 fs1rem'>Turbocharge your finance function with intelligent FP&A agents</p>
                                        <p class='w100 fs1rem my2rem'>Automate analysis, reporting and forecasting - freeing  your team to <br /> focus on higher value insight and strategy</p>
                                        <p class='w100 fs1-25rem fw500 mb2rem'>Need help? You specify in plain English. We can design <br /> and deploy AI agents for you in days for as little as £1,000 <br /> per agent.</p>
                                        <img className="" src={require(`../../../../../../images/thingstodo/knoli_bottom_img.png`)} alt="" />
                                    </div>
                                }
                                {selectedThingsToDo['content'] && (['Due Dig', 'GenFinance.ai', 'Yoono.Ai', 'Kiss The Fish', 'Nume', 'Startup 2 Standup', 'Freshbat Strategic Marketing', 'Go EO', 'Intelect Group', 'Green Ripple', 'Flocast'].includes(selectedThingsToDo['title'])) &&
                                    <div class='w100 df fdc c15 my3rem'>
                                        <p class='w100 c4 fs0-75rem fw500 mb0-5rem'>{selectedThingsToDo['content']['topHeading']}</p>
                                        {selectedThingsToDo['title'] == 'Due Dig' && <p class='w100 fs1rem mb1rem'>Independent, investor-grade tech due diligence - fast, clear, and actionable</p>}
                                        <p class={`w100 fs2rem fw500 lh2 mb1rem`}>{selectedThingsToDo['content']['mainHeading']}</p>
                                        {(selectedThingsToDo['title'] == 'GenFinance.ai' || selectedThingsToDo['title'] == 'Yoono.Ai' || selectedThingsToDo['title'] == 'Kiss The Fish' || selectedThingsToDo['title'] == 'Nume' || selectedThingsToDo['title'] == 'Go EO' || selectedThingsToDo['title'] == 'Green Ripple' || selectedThingsToDo['title'] == 'Flocast') &&
                                            <p class='w100 fs1rem mb2rem'>{selectedThingsToDo?.['content']?.['bottomHeading']}</p>
                                        }
                                        {selectedThingsToDo?.['content']?.['points'] &&
                                            <ul class='pl1rem mb1rem c12'>{selectedThingsToDo?.['content']['points'].map(point => (<li class='mb0-5rem'>{point}</li>))}</ul>
                                        }
                                        {selectedThingsToDo?.['content']?.['boxes'] &&
                                            <div class='df jcfs my1rem'>
                                                {selectedThingsToDo?.['content']['boxes'].map(box => (
                                                    <div class='w25 df fdc jcc p1-5rem bw1px bo16 bss br10px mx0-5rem'>
                                                        <p class='fs1rem fw600 tac'>{box['title']}</p>
                                                        <p class='fs0-75rem fw600 tac'>{box['subTitle']}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        }
                                        {['Due Dig', 'Kiss The Fish', 'Nume', 'Startup 2 Standup', 'Freshbat Strategic Marketing', 'Go EO', 'Intelect Group', 'Green Ripple', 'Flocast'].includes(selectedThingsToDo['title']) && <p class={`w100 c15 fs1rem fw400 my1rem ${selectedThingsToDo['title'] == 'Go EO' && 'mb4rem'}`}>{selectedThingsToDo?.['content']?.['bottomText']}</p>}
                                    </div>
                                }
                            </div>
                        </div>
                        <div class='w30' style={{ backgroundColor: '#99ceff' }}>
                            <div class='df fdc aic w100 h100' style={{ backgroundImage: selectedThingsToDo['rightSideImg'], backgroundPosition: 'center', backgroundSize: 'cover' }}>
                                {selectedThingsToDo['title'] == 'Knolli.ai' &&
                                    <h2 class='c15 fs2rem tac mt3rem lh2'>Book a <br /> discovery call <br /> with a <span class='c4'>human</span></h2>
                                }
                                {selectedThingsToDo['title'] == 'Due Dig' &&
                                    <h2 class='c15 fs2rem tac mt4rem lh1'><span class='fs4rem fw600'>15%</span><br /> off for Diligentsia <br /> <span class='c7'>Pro</span> subscribers</h2>
                                }
                                {selectedThingsToDo['title'] == 'GenFinance.ai' &&
                                    <h2 class='c15 fs2rem tac mt5rem lh2'>Free discovery call <br /> for Diligentsia <br /> <span class='c7'>Pro</span> subscribers</h2>
                                }
                                {selectedThingsToDo['title'] == 'Yoono.Ai' &&
                                    <img className="" src={require(`../../../../../../images/thingstodo/yoono.ai_right_img.png`)} alt="" />
                                }
                                {selectedThingsToDo['title'] == 'Kiss The Fish' &&
                                    <p class='c15 fs2rem fw400 tal mt5rem lh2 px3rem'>Book your call now & get a free 30-minute revenue growth session</p>
                                }
                                {selectedThingsToDo['title'] == 'Nume' &&
                                    <p class='c15 fs2rem fw400 tal mt5rem lh2 px3rem'>Try for FREE for 45 days - see real‑time financial insights from your own data</p>
                                }
                                {selectedThingsToDo['title'] == 'Startup 2 Standup' && <>
                                    <img class='w60 mt1rem ml6rem' src={require('../../../../../../images/thingstodo/startup2standup_popup.png')} />
                                    <p class='c15 fs1rem fw200 tal mt3rem lh2 px2rem'>Let our community help you get to where you want to get, more quickly with less stress</p>
                                    <p class='c15 fs2rem fw400 tal my3rem lh2 px2rem'>Limited free trial access or introductory founder session</p>
                                </>}
                                {selectedThingsToDo['title'] == 'Freshbat Strategic Marketing' && <>
                                    <img class='w60 mt1-5rem ml6rem' src={require('../../../../../../images/thingstodo/startup2standup_popup.png')} />
                                    <p class='c15 fs1rem fw200 tal mt3rem lh2 px3rem'>Introductory GTM strategy boost — fast, focused and affordable</p>
                                    <p class='c15 fs2rem fw400 tal my3rem lh2 px3rem'>Book a GTM strategy boost to improve investor confidence</p>
                                </>}
                                {selectedThingsToDo['title'] == 'Go EO' && <>
                                    <img class='w60 mt1rem ml6rem' src={require('../../../../../../images/thingstodo/startup2standup_popup.png')} />
                                    <p class='c15 fs2rem fw400 tal mt6rem lh2 px3rem'>Get in touch with <br /> the EOT experts </p>
                                </>}
                                {selectedThingsToDo['title'] == 'Intelect Group' && <>
                                    <img class='w60 mt1rem ml6rem' src={require('../../../../../../images/thingstodo/startup2standup_popup.png')} />
                                    <p class='c15 fs2rem fw400 tal mt2rem lh2 px3rem'>Book a discovery call to understand how we can diligence quickly</p>
                                </>}
                                {/* {selectedThingsToDo['title'] == 'Brown Rudnick LLP' && <>
                                    <img class='w60 mt1rem ml6rem' src={require('../../../../../../images/thingstodo/startup2standup_popup.png')} />
                                    <p class='c15 fs1rem fw200 tal mt1-5rem lh2 px2rem'>“This is the result of my experience of 600 career transactions and advising on 20 VC investments a year....”</p>
                                    <p class='c15 fs1-5rem fw400 tal my1rem lh2 px2rem'>No obligation chat about your transaction plans?</p>
                                    <img class='w35 mt2rem' src={require('../../../../../../images/thingstodo/brownrudnick_popup.png')} />
                                    <p class='c15 fs0-75rem fw200 tac mt1rem lh1 px2rem'>Neil Foster is lead partner in the Emerging Growth Companies & Venture Capital group</p>
                                </>} */}
                                {selectedThingsToDo['title'] == 'Green Ripple' && <>
                                    <img class='w60 mt1rem ml6rem' src={require('../../../../../../images/thingstodo/startup2standup_popup.png')} />
                                    <p class='c15 fs2rem fw400 tal my2rem lh2 px3rem'>Book an investor readiness review — refine your pitch and attract the backers you want</p>
                                </>}
                                {selectedThingsToDo['title'] == 'Flocast' && <>
                                    <img class='w60 mt1rem ml6rem' src={require('../../../../../../images/thingstodo/startup2standup_popup.png')} />
                                    <p class='c15 fs14px fw300 fsi tal my2rem lh2 px3rem'>Founder-friendly, low-cost access to smarter cashflow forecasting</p>
                                    <p class='c15 fs2rem fw400 tal mt2rem mb0-5rem lh2 px3rem'>Book a demo and see how Flocast can strengthen client cashflow visibility</p>
                                </>}
                                {/* Book Call Button */}
                                <a href={selectedThingsToDo['bookCall']} target='_blank' className="w50 cp bg4 br40px df jcsb aic px1rem py0-5rem mt2rem">
                                    <div class='df aic'>
                                        <svg width="27" height="27" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.9" d="M33.3804 4.33135H30.3365C30.3365 4.06704 30.2812 3.80565 30.1742 3.56399C30.0671 3.32233 29.9106 3.10577 29.7148 2.92823C29.519 2.75069 29.2882 2.61612 29.0373 2.53317C28.7863 2.45022 28.5207 2.42072 28.2577 2.44659C27.7806 2.50563 27.3422 2.73901 27.0268 3.10184C26.7115 3.46466 26.5414 3.93129 26.5493 4.41196V5.27811C26.5493 5.7122 26.6983 6.13314 26.9716 6.47044C27.2448 6.80774 27.6256 7.04092 28.0503 7.13093C28.1718 7.15386 28.2795 7.22337 28.3505 7.32465C28.4215 7.42592 28.45 7.55091 28.4301 7.67296C28.4102 7.795 28.3433 7.90441 28.2438 7.97784C28.1443 8.05127 28.0201 8.0829 27.8976 8.06597C27.2514 7.93885 26.6694 7.59143 26.2509 7.083C25.8323 6.57457 25.6032 5.93665 25.6026 5.27811V4.33135H20.329C20.3267 4.08071 20.2747 3.83301 20.1759 3.60262C20.0772 3.37224 19.9337 3.16374 19.7537 2.98923C19.5738 2.81471 19.361 2.67764 19.1277 2.58597C18.8944 2.49429 18.6453 2.44983 18.3947 2.45517C18.1441 2.46051 17.897 2.51553 17.6678 2.61705C17.4387 2.71858 17.2319 2.86458 17.0596 3.04659C16.8872 3.22861 16.7527 3.44302 16.6639 3.67741C16.575 3.91179 16.5336 4.16147 16.5419 4.41199L16.5419 5.27811C16.5418 5.7122 16.6909 6.13313 16.9641 6.47043C17.2374 6.80773 17.6182 7.04091 18.0428 7.13093C18.1643 7.15388 18.272 7.2234 18.343 7.32467C18.4139 7.42593 18.4425 7.55091 18.4225 7.67293C18.4026 7.79496 18.3358 7.90436 18.2363 7.97779C18.1368 8.05121 18.0126 8.08285 17.8901 8.06595C17.244 7.93882 16.662 7.5914 16.2434 7.08297C15.8249 6.57455 15.5957 5.93663 15.5951 5.27809V4.33135H12.5512C11.7984 4.33275 11.0767 4.63244 10.5444 5.1648C10.012 5.69716 9.71233 6.41879 9.71094 7.17165V9.80842H36.2207V7.17165C36.2193 6.41878 35.9196 5.69715 35.3872 5.1648C34.8549 4.63244 34.1332 4.33275 33.3804 4.33135ZM17.4887 4.33135C17.4924 4.08268 17.5937 3.84544 17.7709 3.67089C17.9481 3.49634 18.1868 3.3985 18.4355 3.3985C18.6842 3.39851 18.9229 3.49636 19.1 3.67091C19.2772 3.84547 19.3786 4.08272 19.3822 4.33139L17.4887 4.33135ZM27.4961 4.33135C27.4998 4.08268 27.6012 3.84544 27.7784 3.67089C27.9555 3.49634 28.1942 3.3985 28.4429 3.3985C28.6916 3.39851 28.9303 3.49636 29.1075 3.67091C29.2846 3.84547 29.386 4.08272 29.3897 4.33139L27.4961 4.33135Z" fill="#FEFEFE" />
                                            <path opacity="0.9" d="M9.74219 17.1934C9.87852 17.459 10.8695 19.0329 10.954 19.27C11.2572 19.9563 11.3021 20.729 11.0806 21.4458C10.8591 22.1626 10.386 22.7752 9.74849 23.1707C9.7935 23.9237 10.1243 24.6311 10.6733 25.1485C11.2223 25.6658 11.9481 25.954 12.7024 25.9543H33.2286C34.0134 25.9531 34.7657 25.6409 35.3206 25.086C35.8755 24.5311 36.1877 23.7788 36.1888 22.994V11.0078H9.74219V17.1934ZM30.4261 13.3495C30.6717 13.3528 30.9061 13.4527 31.0786 13.6275C31.251 13.8023 31.3477 14.0381 31.3477 14.2837C31.3477 14.5292 31.251 14.765 31.0785 14.9398C30.906 15.1146 30.6717 15.2145 30.4261 15.2178C30.1805 15.2145 29.9461 15.1146 29.7736 14.9398C29.6012 14.7649 29.5045 14.5292 29.5045 14.2836C29.5045 14.038 29.6012 13.8023 29.7737 13.6275C29.9462 13.4527 30.1805 13.3528 30.4261 13.3495ZM30.4261 17.5469C30.6716 17.5503 30.9059 17.6502 31.0783 17.8251C31.2506 17.9999 31.3473 18.2355 31.3473 18.481C31.3473 18.7266 31.2506 18.9622 31.0782 19.137C30.9058 19.3118 30.6716 19.4117 30.4261 19.4152C30.1806 19.4117 29.9463 19.3118 29.7739 19.137C29.6016 18.9622 29.5049 18.7265 29.5049 18.481C29.5049 18.2355 29.6016 17.9999 29.774 17.825C29.9464 17.6502 30.1806 17.5503 30.4261 17.5469ZM30.4261 21.7442C30.6717 21.7475 30.9061 21.8474 31.0786 22.0223C31.251 22.1971 31.3477 22.4328 31.3477 22.6784C31.3477 22.924 31.251 23.1597 31.0785 23.3345C30.906 23.5094 30.6717 23.6092 30.4261 23.6126C30.1805 23.6092 29.9461 23.5093 29.7736 23.3345C29.6012 23.1597 29.5045 22.924 29.5045 22.6784C29.5045 22.4328 29.6012 22.1971 29.7737 22.0222C29.9462 21.8474 30.1805 21.7475 30.4261 21.7442ZM22.9655 13.3495C23.2111 13.3528 23.4455 13.4527 23.618 13.6275C23.7905 13.8023 23.8872 14.0381 23.8872 14.2837C23.8872 14.5292 23.7904 14.765 23.618 14.9398C23.4455 15.1146 23.2111 15.2145 22.9655 15.2178C22.7199 15.2145 22.4855 15.1146 22.3131 14.9398C22.1406 14.7649 22.0439 14.5292 22.0439 14.2836C22.0439 14.038 22.1406 13.8023 22.3131 13.6275C22.4856 13.4527 22.72 13.3528 22.9655 13.3495ZM22.9655 17.5469C23.211 17.5503 23.4453 17.6502 23.6177 17.8251C23.7901 17.9999 23.8867 18.2355 23.8867 18.481C23.8867 18.7266 23.79 18.9622 23.6177 19.137C23.4453 19.3118 23.211 19.4117 22.9655 19.4152C22.72 19.4117 22.4857 19.3118 22.3134 19.137C22.141 18.9622 22.0443 18.7265 22.0443 18.481C22.0443 18.2355 22.141 17.9999 22.3134 17.825C22.4858 17.6502 22.7201 17.5503 22.9655 17.5469ZM22.9655 21.7442C23.2111 21.7475 23.4455 21.8474 23.618 22.0223C23.7905 22.1971 23.8872 22.4328 23.8872 22.6784C23.8872 22.924 23.7904 23.1597 23.618 23.3345C23.4455 23.5094 23.2111 23.6092 22.9655 23.6126C22.7199 23.6092 22.4855 23.5094 22.3131 23.3345C22.1406 23.1597 22.0439 22.924 22.0439 22.6784C22.0439 22.4328 22.1406 22.1971 22.3131 22.0222C22.4856 21.8474 22.72 21.7475 22.9655 21.7442ZM15.505 13.3495C15.7493 13.3547 15.9818 13.4554 16.1527 13.63C16.3237 13.8047 16.4194 14.0393 16.4194 14.2837C16.4194 14.528 16.3236 14.7626 16.1527 14.9373C15.9818 15.1119 15.7492 15.2126 15.5049 15.2178C15.2606 15.2126 15.0281 15.1119 14.8572 14.9373C14.6862 14.7626 14.5905 14.528 14.5905 14.2836C14.5905 14.0393 14.6862 13.8046 14.8572 13.63C15.0281 13.4554 15.2607 13.3547 15.505 13.3495ZM15.505 17.5469C15.7493 17.552 15.9819 17.6527 16.1529 17.8273C16.3239 18.002 16.4196 18.2366 16.4196 18.481C16.4196 18.7254 16.3239 18.9601 16.1529 19.1347C15.9819 19.3094 15.7493 19.41 15.5049 19.4152C15.2606 19.41 15.028 19.3093 14.857 19.1347C14.686 18.9601 14.5902 18.7254 14.5902 18.481C14.5902 18.2366 14.686 18.002 14.857 17.8273C15.028 17.6527 15.2606 17.552 15.505 17.5469ZM15.505 21.7442C15.7493 21.7494 15.9819 21.8501 16.1529 22.0247C16.3239 22.1993 16.4197 22.434 16.4196 22.6784C16.4196 22.9228 16.3239 23.1575 16.1529 23.3321C15.9819 23.5067 15.7493 23.6074 15.5049 23.6126C15.2606 23.6074 15.028 23.5067 14.857 23.3321C14.686 23.1575 14.5902 22.9228 14.5902 22.6784C14.5902 22.434 14.686 22.1993 14.857 22.0247C15.028 21.85 15.2606 21.7494 15.505 21.7442Z" fill="#FEFEFE" />
                                            <path d="M21.993 30.9786L19.7586 29.6342C19.5111 29.4866 19.2327 29.3987 18.9453 29.3775C18.6579 29.3563 18.3695 29.4024 18.1031 29.512C17.8366 29.6217 17.5993 29.7919 17.4101 30.0092C17.2209 30.2266 17.0849 30.485 17.013 30.7641C16.9356 30.9948 16.8076 31.2054 16.6383 31.3802C16.4689 31.5551 16.2626 31.6898 16.0344 31.7746C15.8062 31.8593 15.5619 31.8919 15.3195 31.8699C15.0771 31.848 14.8427 31.772 14.6334 31.6476C13.2117 30.7997 11.9014 29.7777 10.7327 28.6054C9.56324 27.4388 8.54149 26.133 7.69034 24.7173C7.56427 24.5008 7.48903 24.2585 7.47032 24.0087C7.4516 23.7589 7.4899 23.5081 7.58232 23.2753C7.67473 23.0424 7.81885 22.8336 8.00378 22.6646C8.18871 22.4957 8.40963 22.3709 8.64984 22.2998C8.89934 22.2223 9.12966 22.0929 9.32573 21.9202C9.52179 21.7475 9.67919 21.5353 9.78762 21.2976C9.89604 21.0599 9.95306 20.802 9.95494 20.5407C9.95681 20.2794 9.90351 20.0207 9.79851 19.7814C9.84927 19.8024 8.3863 17.4031 8.35944 17.345C8.10616 16.9272 7.69801 16.6264 7.22391 16.5081C6.74982 16.3899 6.24821 16.4639 5.8284 16.7139C4.45345 17.5364 3.44502 18.8536 3.00966 20.3955C2.57429 21.9374 2.74495 23.5875 3.48667 25.0076C5.89802 29.647 9.67986 33.431 14.3178 35.8451C15.738 36.5888 17.3888 36.7613 18.9321 36.3271C20.4753 35.8929 21.794 34.8849 22.6179 33.5097C22.8707 33.0912 22.9468 32.5894 22.8297 32.1147C22.7125 31.6401 22.4115 31.2314 21.993 30.9786Z" fill="#FEFEFE" />
                                        </svg>
                                        <span className="c1 fs0-875rem fw600 ml0-5rem">Book a Call</span>
                                    </div>
                                    <svg width="20" height="17" viewBox="0 0 28 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.57843 14.5715H21.6274L15.8315 21.1082C14.1667 22.9858 16.6639 25.8021 18.3287 23.9245L23.6072 17.9621L27.1308 13.9818C27.8138 13.207 27.8138 11.9557 27.1308 11.1809L18.3287 1.24207C17.9938 0.853956 17.5329 0.636189 17.0526 0.640694C15.4672 0.640919 14.6892 2.8187 15.8315 4.05856L21.6411 10.5953H2.48727C0.0456802 10.7319 0.227984 14.7086 2.57843 14.5715Z" fill="white" />
                                    </svg>
                                </a>
                                {selectedThingsToDo['title'] == 'Green Ripple' && <>
                                    <p class='c15 fs0-75rem fw300 tal mt3rem lh2 px3rem'>“Highly recommended - after 30 years of doing this stuff...GR have taught me loads whilst going through their process with Diligentsia itself.  They tell you what you don’t want to hear!”</p>
                                    <p class='w100 c15 fs0-75rem fw500 tal mt0-5rem lh2 px3rem'>Mark Bernstein, Founder, Diligentsia</p>
                                </>}
                                {selectedThingsToDo['title'] == 'Flocast' && <>
                                    <p class='c15 fs14px fw300 fsi tal mt5rem mb3rem lh2 px3rem'>Use promo code : Dili30 to get your discount courtesy of Flocast</p>
                                </>}
                            </div>
                        </div>
                    </>}

                    <svg className="pa cp" onClick={() => { setSelectedThingsToDo({}), dispatch(toggleModal({ open: '' })) }} style={{ left: '650px', bottom: '-80px' }} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect opacity="0.8" x="4" y="4" width="52" height="52" rx="26" fill="#151313" />
                        <path d="M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z" fill="white" />
                    </svg>
                </div>
            </Modal>
        </div>
    )
}

export default AppStore